import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/"); else setError(res.error || "Error");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[var(--paper)]">
      <div className="hidden lg:flex items-center justify-center bg-zinc-900 text-white p-12">
        <div className="max-w-md">
          <img
            src="/assets/logo.png"
            alt="Quilles Varilleros"
            className="w-44 h-auto mb-10 invert"
          />
          <h1 className="font-display text-5xl leading-[1.05] mb-6">
            Gestión PDR<br />sin perder<br />un solo bollo.
          </h1>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Expedientes, presupuestos por panel, sugerencias por IA y facturas
            con tu identidad — todo en un mismo flujo.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-display text-3xl mb-1">Acceder</h2>
          <p className="text-sm text-zinc-500 mb-8">Introduce tus credenciales para entrar.</p>

          <div className="mb-4">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email}
                   onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
          </div>
          <div className="mb-6">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" data-testid="login-password" type="password" value={password}
                   onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
          </div>
          {error && <div className="text-sm text-red-600 mb-4" data-testid="login-error">{error}</div>}
          <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full">
            {loading ? "Entrando…" : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
